import React from 'react';
import { Layout } from '@/components/Layout';
import { Info, Target, Lightbulb } from 'lucide-react';

export default function About() {
  return (
    <Layout>
      <div className="container mx-auto px-4 md:px-6 py-12 max-w-4xl">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="bg-primary/10 p-4 rounded-2xl mb-4">
            <Info className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight mb-4">关于我们</h1>
          <div className="h-1.5 w-20 bg-primary rounded-full" />
        </div>

        <div className="space-y-12 text-lg leading-relaxed text-muted-foreground">
          <section className="bg-card border rounded-3xl p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <Target className="h-6 w-6 text-primary" />
              <h2 className="text-2xl font-bold text-foreground">平台愿景</h2>
            </div>
            <p className="mb-4">
              <span className="text-primary font-bold">万象聚聚官 2135C</span> 是一个专注于自媒体全流程教程聚合的实用导航平台。
            </p>
            <p>
              我们的核心目标，是为自媒体新手、创作者、剪辑爱好者与运营人员，提供一个清晰、高效、集中式的学习资源入口。
            </p>
          </section>

          <section className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-xl font-bold text-foreground flex items-center gap-2">
                <span className="h-2 w-2 bg-primary rounded-full" />
                一站式资源
              </h3>
              <ul className="space-y-2 list-disc list-inside text-sm">
                <li>自媒体入门定位与起号教程</li>
                <li>短视频拍摄与剪辑全流程</li>
                <li>文案写作、脚本创作、标题打造方法</li>
                <li>运营涨粉、流量解析、爆款内容复盘</li>
                <li>AI 工具使用、AI 创作、AI 剪辑实战</li>
                <li>变现路径、商业化项目与干货教程</li>
              </ul>
            </div>
            <div className="bg-primary/5 rounded-3xl p-8 flex flex-col justify-center border border-primary/10">
              <Lightbulb className="h-10 w-10 text-primary mb-4" />
              <h3 className="text-xl font-bold text-foreground mb-2">我们的理念</h3>
              <p className="text-sm">
                我们坚持 “整理资源・高效学习” 的理念，持续收录优质内容，优化页面结构，让用户在最短时间内找到需要的资料。
              </p>
            </div>
          </section>

          <p className="text-center italic">
            本平台持续更新，欢迎随时访问。
          </p>
        </div>
      </div>
    </Layout>
  );
}
